import axiosClient from 'api/shared/AxiosClient';

class RoleService {

    getRoles = async () => {
        const resp = await axiosClient.get('/roles?limit=100');
        return resp.data;
    }

    getPermissions = async () => {
        const resp = await axiosClient.get('/roles/permissions');
        return resp.data.permissions;
    }

    createRole = async (data) => {
        const resp = await axiosClient.post('/roles', data);
        return resp.data;
    }

    updateRole = async (id, data) => {
        const resp = await axiosClient.patch(`/roles/${id}`, data);
        return resp.data;
    }

    deleteRole = async (id) => {
        await axiosClient.delete(`/roles/${id}`);
    }
}

const roleService = new RoleService();
export default roleService;
